export const toEuroString = amount => {
    return amount.toFixed(2).toString().replace(".", ",") + " €";
};
